import React from 'react';

const InfoIcon:React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
        <circle cx="12" cy="12" r="9" stroke="#112240" stroke-width="2"/>
        <path fill="#112240" d="M11 11H13V17H11zM11 7H13V9H11z"/>
    </svg>
  )
}

export default InfoIcon;